import { render, staticRenderFns } from "./IrReturnedPackageTrackBarcodeViewerActivator.vue?vue&type=template&id=08da54ee&"
import script from "./IrReturnedPackageTrackBarcodeViewerActivator.vue?vue&type=script&lang=js&"
export * from "./IrReturnedPackageTrackBarcodeViewerActivator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports